module.exports = __webpack_public_path__ + "img/flags.45ef8c91.png";